<template>
    <div class="tabbar">
        <van-tabbar :safe-area-inset-bottom="true" route z-index="10001" active-color="#009AF3">
            <van-tabbar-item v-for="(item, index) in tabbarList" :key="index" replace :to="item.route">
                <span>{{ item.name }}</span>
                <template #icon="props">
                    <img :src="props.active ? item.iconA : item.icond" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    name: "Tabbar",
    data() {
        return {
            loginFlag: false,
            tabbarList: [
                {
                    name: "首页",
                    icond: require("../../assets/images/tabbar/home.png"),
                    iconA: require("../../assets/images/tabbar/homeA.png"),
                    route: "/home",
                },
                // {
                //     name: "记录",
                //     icond: require("@/assets/images/tabbar/record.png"),
                //     iconA: require("@/assets/images/tabbar/recordA.png"),
                //     route: "/record",
                // },
                {
                    name: "停车",
                    icond: require("@/assets/images/tabbar/parking.png"),
                    iconA: require("@/assets/images/tabbar/parkingA.png"),
                    route: "/parking",
                },
                {
                    name: "我的",
                    icond: require("@/assets/images/tabbar/mine.png"),
                    iconA: require("@/assets/images/tabbar/mineA.png"),
                    route: "/mine",
                },

                // {
                //     name: "test",
                //     icond: require("@/assets/images/tabbar/mine.png"),
                //     iconA: require("@/assets/images/tabbar/mineA.png"),
                //     route: "/test",
                // },
            ],
        };
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.tabbar {
}
</style>
